<script>
export default {
  name: 'TransactionCard',
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
    paymentMethodCard: {
      type: Boolean,
      required: false,
      default: false,
    },
    containerClasses: {
      type: String,
      required: false,
      default: 'col-md-12 col-lg-4',
    },
  },
  data() {
    return {
      cardClasses: {
        'gl-p-6': true,
        'gl-border-solid': true,
        'gl-border-1': true,
        'gl-rounded-base': true,
        'gl-bg-blue-50': this.paymentMethodCard,
        'gl-border-blue-200': this.paymentMethodCard,
        'gl-border-gray-200': !this.paymentMethodCard,
      },
    };
  },
};
</script>

<template>
  <section :class="containerClasses">
    <div class="my-4 font-weight-bold gl-text-gray-600" data-testid="transaction-card-title">
      {{ title }}
    </div>
    <div :class="cardClasses">
      <slot></slot>
    </div>
  </section>
</template>
